import React from "react";

    const Cards = ({ name, email, id }) => {
        return (
          <div className={'tc grow bg-light-green br3 pa3 ma2 dib bw2 shadow-5'}>
            <img alt={'robots'} src={`https://robohash.org/set=set3.8${id}?200x200`}/>
              <div>
                  <h2>{name}</h2>
                  <p>{email}</p>
              </div>
          </div>
        );
    }

export default Cards;